<script setup>
import { computed, ref } from 'vue';
import { vOnClickOutside } from '@vueuse/components';
import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const props = defineProps({
  channels: { type: Array, required: true },
  activeId: { type: [Number, String], default: null },
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits(['select']);
const isOpen = ref(false);
const trigger = ref(null);
const activeChannel = computed(() =>
  props.channels.find(channel => Number(channel.id) === Number(props.activeId))
);
const menuItems = computed(() =>
  props.channels.map(channel => ({
    ...channel,
    value: channel.id,
    isSelected: Number(channel.id) === Number(props.activeId),
  }))
);
const close = () => {
  isOpen.value = false;
};
const select = item => {
  emit('select', item.value);
  close();
  trigger.value?.$el?.focus();
};
</script>

<template>
  <div
    v-on-click-outside="close"
    class="relative min-w-0"
    @keydown.esc.stop="close"
  >
    <Button
      ref="trigger"
      ghost
      slate
      sm
      :disabled="disabled"
      :aria-expanded="isOpen"
      :aria-label="
        activeChannel?.label || $t('CONVERSATION.REPLYBOX.SELECT_REPLY_CHANNEL')
      "
      class="max-w-52 !gap-2"
      @click="isOpen = !isOpen"
    >
      <Icon
        :icon="activeChannel?.icon || 'i-lucide-message-square'"
        class="size-4 shrink-0"
      />
      <span class="truncate">{{
        activeChannel?.label || $t('CONVERSATION.REPLYBOX.SELECT_REPLY_CHANNEL')
      }}</span>
      <Icon icon="i-lucide-chevron-down" class="size-3 shrink-0" />
    </Button>
    <DropdownMenu
      v-if="isOpen"
      :menu-items="menuItems"
      class="bottom-full mb-2 ltr:left-0 rtl:right-0 w-56"
      @action="select"
    >
      <template #trailing-icon="{ item }">
        <Icon
          v-if="item.isSelected"
          icon="i-lucide-check"
          class="size-4 shrink-0 ltr:ml-auto rtl:mr-auto text-n-brand"
        />
      </template>
    </DropdownMenu>
  </div>
</template>
